import React from 'react'
import styled from '@emotion/styled'
import cn from 'classnames'
import {
  heading,
  paragraph,
  text,
  button,
} from '@groovehq/internal-design-system/lib/styles/elements'
import NewLabel from '@groovehq/internal-design-system/lib/components/NewLabel/NewLabel'
import { styles } from './styles'

const Item = styled('button', {
  // Don't pass activeColor to DOM
  // If shouldForwardProp is called, need to filter out "as" prop too, otherwise "as" won't work
  shouldForwardProp: prop => !['activeColor', 'as'].includes(prop),
})`
  ${button.styles.preflight};
  ${styles.menuItem};
`

const MenuItem = ({
  className,
  icon,
  title,
  copy,
  to,
  isActive,
  as,
  onClick,
  recommended,
  activeColor = 'color.info.100',
  dataTestId,
  isNew,
  ...rest
}) => {
  return (
    <Item
      className={cn('grui relative', className, { active: isActive })}
      as={as}
      role="menuitem"
      to={to}
      onClick={onClick}
      activeColor={activeColor}
      data-test-id={dataTestId}
      {...rest}
    >
      <div css={styles.menuItemIcon} className="grui mr-7 menu-item-icon">
        {icon}
      </div>
      <div>
        <h5
          css={[heading.styles.h5, text.styles.textSm]}
          className="grui mb-3 flex items-center"
        >
          {title}
          {isNew && (
            <NewLabel className="grui ml-5" isInfiniteAnimation size="small" />
          )}
        </h5>
        <p css={[paragraph.styles.preflight, text.styles.textSm]}>{copy}</p>
      </div>
      {recommended && (
        <div css={styles.recommendedIndicator}>
          <strong>Recommended</strong>
        </div>
      )}
    </Item>
  )
}

export default MenuItem
